import _typeof from "@babel/runtime/helpers/esm/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["showConfirmation"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import createRetailMFEStore from '@nike/shop-apis/store/retail-mfe/create-store';
import get from './public-functions/get';
// import initV2 from './v2/init';
import createErrorModalStore from "../store/error-modal/create-store";
import createItemAddedModalStore from "../store/item-added-modal/create-store";
import createShopDialogStore from "../store/shop-dialog/create-store";
/**
 * The NikeShop class creates a singleton instance per load via nike-shop-client, exposing some public methods that client experiences can use to interface with apis related to shopping
 *
 * @class
 */
var createDeprecatedStoreWarning = function createDeprecatedStoreWarning(storeName) {
  return "[NikeShop] `".concat(storeName, "` is deprecated and will be removed in a future release. ") + 'Migrate to React Query hooks. See #help-cart-wishlist-ux for guidance.';
};
function createDeprecatedStore(storeName) {
  var deprecatedStoreWarning = createDeprecatedStoreWarning(storeName);
  var warn = function warn(method) {
    // eslint-disable-next-line no-console
    console.warn("".concat(deprecatedStoreWarning, " Called: ").concat(method, "()"));
  };
  return {
    getState: function getState() {
      warn('getState');
      return {};
    },
    dispatch: function dispatch(action) {
      warn('dispatch');
      return action;
    },
    subscribe: function subscribe() {
      warn('subscribe');
      return function () {};
    },
    replaceReducer: function replaceReducer() {
      warn('replaceReducer');
    }
  };
}
var NikeShop = /*#__PURE__*/_createClass(function NikeShop() {
  var _this = this;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, NikeShop);
  /**
   * @memberof NikeShop
   * @name NikeShop.getVersion
   * @returns {string} the page instawntiated script's module version
   */
  _defineProperty(this, "getVersion", function () {
    return _this.version;
  });
  /**
   * @memberof NikeShop
   * @name NikeShop.addToCart
   * @description add to a user cart with skuId or skuId and designViewId. For additional arguments see reference:
   * @see {@link https://github.com/nike-internal/dotcom.shop-modules/tree/main/packages/ux-tread-cart-redux#addtocart}
   *
   * @param {object} params - named parameters
   * @param {string} params.skuId - a valid sku uuid
   * @param {number} [params.quantity=1] - optional quantity for skuId to add to cart, defaults to 1
   * @param {string} [params.designViewId] -  optional unique identifiers for any customization items.
   * @param {Array} [params.designViewIds] - array of unique identifiers for any customization items.
   * @param {{ amount: number }} [params.giftCard] - optional gift card object with amount
   * @param {boolean} [params.isDigitalGiftCard] - optional is digital gift card
   * @param {boolean} [params.isPhysicalGiftCard] - optional is physical gift card
   * @param {string}  [params.offer] - optional UUID for exclusive access offer
   * @param {Array<{ id: string, type: string}>}  [params.offers] - optional offers for ExAx and NCP. This section is not intended for CN
   * @param {{ firstName: string, lastName: string }} [params.recipient] - optional object containing gift card recipient with firstName and lastName
   * @param {string} [params.recipientEmailAddress] - optional gift card recipient's email
   * @param {string} [params.shippingMethod] - optional shipping method for a gift card
   * @param {Array<{ id: string, instruction: { id: string, type: string }}>} [params.valueAddedServices] - optional vas info for item
   * @param {boolean} [params.showConfirmation=false] - optional flag to show the add to cart modal/mini-cart flyout after successful add   *
   * @returns {Promise<{ payload: { data: Object } }>} Cart data wrapped in legacy Redux action
   *   shape (`{ payload: { data: cartData } }`) for backward compatibility with external
   *   consumers (e.g. SNKRS web). See MYBAG-5590.
   */
  _defineProperty(this, "addToCart", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var showConfirmation, addToCartParams, _yield$import, getAddToCartOptions, queryClient, result;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            showConfirmation = params.showConfirmation, addToCartParams = _objectWithoutProperties(params, _excluded);
            _context.next = 1;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require('@nike/shop-apis/buy/carts/v2/add-item/get-options'));
            });
          case 1:
            _yield$import = _context.sent;
            getAddToCartOptions = _yield$import["default"];
            queryClient = _this.__INTERNAL_USE__.queryClient; // Error handling is dispatched from the options mutationFn
            // If mutation fails, execute() throws and confirmation won't be shown
            _context.next = 2;
            return queryClient.getMutationCache().build(queryClient, _objectSpread(_objectSpread({}, getAddToCartOptions({
              queryClient: queryClient
            })), {}, {
              variables: addToCartParams
            })).execute();
          case 2:
            result = _context.sent;
            if (showConfirmation) {
              _this.toggleAddToCartModal();
            }

            // Wrap in legacy Redux action shape for backward compatibility with consumers
            // that expect { payload: { data: cartData } } (e.g. SNKRS web)
            return _context.abrupt("return", {
              payload: {
                data: result
              }
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "updateCartItem", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var _yield$import2, getUpdateCartItemOptions, queryClient;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require('@nike/shop-apis/buy/carts/v2/update-item/get-options'));
            });
          case 1:
            _yield$import2 = _context2.sent;
            getUpdateCartItemOptions = _yield$import2["default"];
            queryClient = _this.__INTERNAL_USE__.queryClient;
            _context2.next = 2;
            return queryClient.getMutationCache().build(queryClient, _objectSpread(_objectSpread({}, getUpdateCartItemOptions({
              queryClient: queryClient
            })), {}, {
              variables: {
                itemData: params
              }
            })).execute();
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
  /**
   * @memberof NikeShop
   * @name NikeShop.addToWishlist
   * @description add a product with a valid productId, and optional skuId to a user's default wishlist. If the default wishlist doesn't exist this function will ensure creating one prior to the add.
   *
   * @see {@link https://github.com/nike-internal/dotcom.shop-modules/tree/main/packages/wishlist-redux#initializewishlistandaddtocart}
   *
   * @param {object} params - named parameters
   * @param {string} [params.skuId] - a valid sku uuid (required for wishlist v1)
   * @param {string} [params.productId] - a valid product id (required for wishlist v1)
   * @param {string} [params.gtin] - Global Trade Item Number (required for wishlist v2)
   * @param {string} [params.productCode] - product code identifier (required for wishlist v2)
   * @param {boolean} [params.showConfirmation=false] - optional flag to show the add to favorites modal after successful add
   *
   * @returns {Promise} thenable result
   */
  _defineProperty(this, "addToWishlist", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
      var skuId, productId, gtin, productCode, _ref3$showConfirmatio, showConfirmation, _yield$import3, addToWishlist, result;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            skuId = _ref3.skuId, productId = _ref3.productId, gtin = _ref3.gtin, productCode = _ref3.productCode, _ref3$showConfirmatio = _ref3.showConfirmation, showConfirmation = _ref3$showConfirmatio === void 0 ? false : _ref3$showConfirmatio;
            _context3.next = 1;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require("../api/wishlists/add-to-wishlist"));
            });
          case 1:
            _yield$import3 = _context3.sent;
            addToWishlist = _yield$import3["default"];
            _context3.next = 2;
            return addToWishlist({
              skuId: skuId,
              productId: productId,
              gtin: gtin,
              productCode: productCode
            });
          case 2:
            result = _context3.sent;
            if (showConfirmation) {
              _this.toggleAddToFavoritesModal();
            }
            return _context3.abrupt("return", result);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "removeItemsFromWishlist", /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
      var ids, _yield$import4, removeFromWishlist;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            ids = _ref5.ids;
            _context4.next = 1;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require("../api/wishlists/remove-from-wishlist"));
            });
          case 1:
            _yield$import4 = _context4.sent;
            removeFromWishlist = _yield$import4["default"];
            _context4.next = 2;
            return removeFromWishlist({
              ids: ids
            });
          case 2:
            return _context4.abrupt("return", _context4.sent);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }());
  /**
   * @memberof NikeShop
   * @name NikeShop.fetchCart
   * @description fetch a user's cart
   * @see {@link https://github.com/nike-internal/dotcom.shop-modules/tree/main/packages/ux-tread-cart-redux#fetchCart}
   * @returns {Promise} thenable result
   */
  _defineProperty(this, "fetchCart", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var _yield$import5, isBuyMarketplaceSupported, queryClient, _yield$import6, getFetchCartOptions, data;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@nike/shop-apis/buy/supported-marketplaces'));
          });
        case 1:
          _yield$import5 = _context5.sent;
          isBuyMarketplaceSupported = _yield$import5.isBuyMarketplaceSupported;
          _context5.next = 2;
          return isBuyMarketplaceSupported();
        case 2:
          if (_context5.sent) {
            _context5.next = 3;
            break;
          }
          return _context5.abrupt("return", {
            payload: {
              data: null
            }
          });
        case 3:
          queryClient = _this.__INTERNAL_USE__.queryClient;
          _context5.next = 4;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@nike/shop-apis/buy/carts/v2/fetch/get-options'));
          });
        case 4:
          _yield$import6 = _context5.sent;
          getFetchCartOptions = _yield$import6["default"];
          _context5.next = 5;
          return queryClient.fetchQuery(getFetchCartOptions({
            queryClient: queryClient
          }));
        case 5:
          data = _context5.sent;
          return _context5.abrupt("return", {
            payload: {
              data: data
            }
          });
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })));
  _defineProperty(this, "navigateToCheckout", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var params,
      queryClient,
      _yield$import7,
      navigateToCheckout,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          params = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          queryClient = _this.__INTERNAL_USE__.queryClient;
          _context6.next = 1;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./public-functions/navigate-to-checkout'));
          });
        case 1:
          _yield$import7 = _context6.sent;
          navigateToCheckout = _yield$import7["default"];
          navigateToCheckout(_objectSpread({
            queryClient: queryClient
          }, params));
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  })));
  _defineProperty(this, "toggleDialog", function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _this.__INTERNAL_USE__.stores.shopDialog.toggleDialog(params);
  });
  _defineProperty(this, "toggleAddToCartModal", function () {
    window.NikeShop.__INTERNAL_USE__.stores.itemAddedModal.toggleAddToCartModal();
  });
  _defineProperty(this, "toggleAddToFavoritesModal", function () {
    window.NikeShop.__INTERNAL_USE__.stores.itemAddedModal.toggleAddToFavoritesModal();
  });
  _defineProperty(this, "fetchProductDetails", /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref9) {
      var productId, fetchVasContent, _yield$import8, fetchProductDetails;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            productId = _ref9.productId, fetchVasContent = _ref9.fetchVasContent;
            _context7.next = 1;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require('./public-functions/fetch-product-details'));
            });
          case 1:
            _yield$import8 = _context7.sent;
            fetchProductDetails = _yield$import8["default"];
            return _context7.abrupt("return", fetchProductDetails({
              productId: productId,
              fetchVasContent: fetchVasContent
            }));
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x5) {
      return _ref0.apply(this, arguments);
    };
  }());
  _defineProperty(this, "get", get.bind(this));
  _defineProperty(this, "getBOPIS_EDD_Info", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var params,
      _yield$import9,
      getBOPIS_EDD_Info,
      _args8 = arguments;
    return _regeneratorRuntime.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          params = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _context8.next = 1;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./public-functions/get-bopis-edd-info'));
          });
        case 1:
          _yield$import9 = _context8.sent;
          getBOPIS_EDD_Info = _yield$import9["default"];
          return _context8.abrupt("return", getBOPIS_EDD_Info(params));
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  })));
  this.store = createDeprecatedStore('store');
  this.internalStore = createDeprecatedStore('internalStore');

  /**
   * These aren't safe for use in production.
   * They will be deleted very soon.
   * If using, please contact Cart team in #help-cart-wishlist-ux immediately.
   */

  /* For use by the Cart team only */
  this.__INTERNAL_USE__ = {
    queryClient: props.queryClient,
    stores: {
      errorModal: {
        store: createErrorModalStore(),
        displayErrorModal: function displayErrorModal(error) {
          window.NikeShop.__INTERNAL_USE__.stores.errorModal.store.getState().setError(error);
        }
      },
      itemAddedModal: {
        store: createItemAddedModalStore(),
        toggleAddToCartModal: function toggleAddToCartModal() {
          window.NikeShop.__INTERNAL_USE__.stores.itemAddedModal.store.getState().toggleModal({
            type: 'cart'
          });
        },
        toggleAddToFavoritesModal: function toggleAddToFavoritesModal() {
          window.NikeShop.__INTERNAL_USE__.stores.itemAddedModal.store.getState().toggleModal({
            type: 'favorites'
          });
        }
      },
      shopDialog: {
        store: createShopDialogStore(),
        toggleDialog: function toggleDialog(params) {
          return window.NikeShop.__INTERNAL_USE__.stores.shopDialog.store.getState().toggleDialog(params);
        },
        closeDialog: function closeDialog(params) {
          return window.NikeShop.__INTERNAL_USE__.stores.shopDialog.store.getState().closeDialog(params);
        }
      },
      retailMFE: {
        store: createRetailMFEStore()
      }
    }
  };
});
export { NikeShop as default };